import React, { Component } from "react";
import PropTypes from 'prop-types';

import "./InputSearch.scss";

class InputSearch extends Component {
  static propTypes = {
    placeholder: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onKeyUp: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
  };

  render() {
    const { value, onChange, placeholder, onKeyUp, onClear } = this.props;

    return (
      <div className="search-wrap">
        <input
          className="search-input"
          placeholder={placeholder}
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyUp={(e) => onKeyUp(e.key)}
          maxLength={255}
        />
        <div className="search-icon" />
        {(value && value.length !== 0) ? (
          <button
            type="button"
            className="btn-close clear-search"
            onClick={() => onClear()}
          />
        ) : false}
      </div>
    );
  }
}

export default InputSearch;
